(function () {
  'use strict';
  const cache = new Map();
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const number = value => value === '' || value == null || !Number.isFinite(Number(value)) ? null : Number(value);
  const validPoint = p => Array.isArray(p) && p.length === 2 && p.every(Number.isFinite) && Math.abs(p[0]) <= 90 && Math.abs(p[1]) <= 180 && (p[0] !== 0 || p[1] !== 0);
  const list = value => {
    if (Array.isArray(value)) return value;
    try { const parsed = JSON.parse(value); if (Array.isArray(parsed)) return parsed; } catch (_) { /* Plain lists also occur in legacy records. */ }
    return typeof value === 'string' ? value.split(',').map(s => s.trim()).filter(Boolean) : [];
  };
  const canonical = value => String(value || '').trim().toUpperCase() === 'UK' ? 'GB' : String(value || '').trim().toUpperCase();
  function normalise(raw) {
    if (!raw || !raw.name || !/^[A-Z]{2}$/.test(canonical(raw.country))) return null;
    const coords = [number(raw.lat), number(raw.lon)];
    return {...raw, id:raw.id || raw.name, country:canonical(raw.country), countries_served:(list(raw.countries_served).length ? list(raw.countries_served) : [raw.country]).map(canonical), services:list(raw.services), lat:validPoint(coords) ? coords[0] : null, lon:validPoint(coords) ? coords[1] : null, certified:raw.certified === true || raw.certified === 'true', recommended:raw.recommended === true || raw.recommended === 'true', priority:Math.max(-10000, Math.min(10000, number(raw.priority) || 0))};
  }
  function postcodeKey(cc, input) {
    let s = String(input).trim().toUpperCase().replace(/\s+/g, '');
    if (['CZ','SK','PL','PT','SE'].includes(cc)) s = s.replace(/-/g, '');
    if (['AD','AZ','LT','LV','MD'].includes(cc)) s = s.replace(new RegExp('^'+cc+'-?'), '');
    if (cc === 'NL') return /^[1-9]\d{3}([A-Z]{2})?$/.test(s) ? s.slice(0,4) : '';
    if (['GB','GG','IM','JE'].includes(cc)) {
      const full = s.match(/^([A-Z]{1,2}\d[A-Z\d]?)\d[A-Z]{2}$/);
      return full ? full[1] : (/^[A-Z]{1,2}\d[A-Z\d]?$/.test(s) ? s : '');
    }
    if (cc === 'IE') return /^[A-Z]\d{2}([A-Z\d]{4})?$/.test(s) || /^D6W([A-Z\d]{4})?$/.test(s) ? s.slice(0,3) : '';
    if (cc === 'MT') return /^[A-Z]{3}(\d{4})?$/.test(s) ? s.slice(0,3) : '';
    return s;
  }
  function lookup(data, cc, input) {
    const key = postcodeKey(cc,input);
    return Object.prototype.hasOwnProperty.call(data.postcodes,key) && validPoint(data.postcodes[key]) ? data.postcodes[key] : null;
  }
  function haversine(a,b) {
    const rad = Math.PI/180, dLat=(b[0]-a[0])*rad, dLon=(b[1]-a[1])*rad;
    const h = Math.sin(dLat/2)**2+Math.cos(a[0]*rad)*Math.cos(b[0]*rad)*Math.sin(dLon/2)**2;
    return 6371*2*Math.asin(Math.sqrt(Math.min(1,h)));
  }
  function validate(data, country) {
    if (!data || data.country !== country.code || data.version !== 1 || !data.postcodes || typeof data.postcodes !== 'object' || Array.isArray(data.postcodes) || !Array.isArray(data.towns)) throw new Error('Invalid location data');
    if (Object.keys(data.postcodes).length !== country.postcode_count || data.towns.length !== country.town_count) throw new Error('Incomplete location data');
    if (!Object.values(data.postcodes).every(validPoint) || !data.towns.every(t => t.id && t.name && validPoint(t.point))) throw new Error('Invalid coordinates');
    return data;
  }
  function load(country) {
    if (!country || country.method === 'country-only') return Promise.resolve({postcodes:{},towns:[]});
    if (cache.has(country.url)) return cache.get(country.url);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    const request = fetch(country.url,{signal:controller.signal}).then(r => { if (!r.ok) throw new Error('Location HTTP '+r.status); return r.json(); }).then(data => validate(data,country)).catch(error => { cache.delete(country.url); throw error; }).finally(() => clearTimeout(timer));
    cache.set(country.url,request);
    return request;
  }
  const safeUrl = (value, protocols=['https:','http:']) => {
    if (!value || !String(value).trim()) return '';
    try { const url = new URL(String(value), 'https://flappiedoors.com'); return protocols.includes(url.protocol) ? url.href : ''; } catch (_) { return ''; }
  };
  function init(wrap) {
    if (wrap.dataset.initialised) return;
    const section = wrap.closest('.fl-finder'), read = selector => JSON.parse(section.querySelector(selector).textContent);
    let countries, labels, partners;
    try { countries = read('[data-flappie-countries]'); labels=read('[data-flappie-finder-labels]'); partners=read('[data-flappie-partners]').map(normalise).filter(Boolean); } catch (_) { return; }
    wrap.dataset.initialised = 'true';
    const $ = selector => wrap.querySelector(selector), t = key => labels[key] || key;
    const countryButton=$('.fl-country-toggle'), countrySearch=$('.fl-country-search'), countryPanel=$('.fl-country-panel'), countryOptions=$('.fl-country-options'), input=$('.fl-plz'), go=$('.fl-go'), results=$('.fl-results'), status=$('.fl-status'), town=$('.fl-town'), townSearch=$('.fl-town-search'), cert=$('[data-cert]');
    const limit=Number(wrap.dataset.limit)||9, bonus=Number(wrap.dataset.verifiedBonus)||0;
    const language=wrap.dataset.language || 'de';
    const names = new Intl.DisplayNames([language],{type:'region'});
    const name = code => code === 'XK' ? 'Kosovo' : names.of(code);
    const state={country:'',service:'all',cert:false,origin:null,location:'',shown:limit,request:0,townRequest:0};
    const registry = new Map(countries.map(c => [c.code,c]));
    countries.forEach(c => c.aliases.forEach(alias => registry.set(alias,c)));
    const served = code => partners.filter(p => p.countries_served.includes(code));
    const announce = (message,retry=false) => { status.textContent=message; $('.fl-retry').hidden=!retry; };
    let activeCountry=-1;
    function highlightCountry(index) {
      const options=Array.from(countryOptions.querySelectorAll('[role="option"]'));
      activeCountry=options.length?Math.max(0,Math.min(index,options.length-1)):-1;
      options.forEach((option,i)=>option.classList.toggle('is-active',i===activeCountry));
      countrySearch.removeAttribute('aria-activedescendant');
      if(activeCountry>=0) {
        countrySearch.setAttribute('aria-activedescendant',options[activeCountry].id);
        options[activeCountry].scrollIntoView?.({block:'nearest'});
      }
    }
    function populateCountries() {
      const query=countrySearch.value.trim().toLocaleLowerCase(language);
      const matches=countries.filter(c=>!query || [name(c.code),c.code,...c.aliases].some(value=>value.toLocaleLowerCase(language).includes(query)));
      const group=hasPartners=>{
        const rows=matches.filter(c=>Boolean(served(c.code).length)===hasPartners).sort((a,b)=>name(a.code).localeCompare(name(b.code),language));
        if(!rows.length)return '';
        const label=t(hasPartners?'country_with_partners':'other_countries');
        return '<div role="group" aria-label="'+esc(label)+'"><div class="fl-country-group" aria-hidden="true">'+esc(label)+'</div>'+rows.map(c=>'<div class="fl-country-option" role="option" id="'+esc(wrap.id)+'-country-'+c.code+'" data-country="'+c.code+'" aria-selected="'+(state.country===c.code)+'">'+esc(name(c.code))+'</div>').join('')+'</div>';
      };
      countryOptions.innerHTML=group(true)+group(false);
      $('.fl-country-empty').hidden=matches.length>0;
      highlightCountry(query?0:Array.from(countryOptions.querySelectorAll('[role="option"]')).findIndex(option=>option.dataset.country===state.country));
    }
    function closeCountries(restoreFocus=false) {
      countryPanel.hidden=true;
      countryButton.setAttribute('aria-expanded','false');
      countrySearch.setAttribute('aria-expanded','false');
      countrySearch.removeAttribute('aria-activedescendant');
      if(restoreFocus)countryButton.focus();
    }
    function openCountries() {
      countryPanel.hidden=false;countrySearch.value='';
      countryButton.setAttribute('aria-expanded','true');
      countrySearch.setAttribute('aria-expanded','true');
      populateCountries();countrySearch.focus();
    }
    function chooseCountry(cc) {
      changeCountry(cc);closeCountries(true);
    }
    countryButton.addEventListener('click',()=>countryPanel.hidden?openCountries():closeCountries());
    countryButton.addEventListener('keydown',e=>{if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();openCountries();}});
    countrySearch.addEventListener('input',populateCountries);
    countrySearch.addEventListener('keydown',e=>{
      if(e.key==='ArrowDown'||e.key==='ArrowUp') { e.preventDefault();highlightCountry(activeCountry+(e.key==='ArrowDown'?1:-1)); }
      if(e.key==='Enter') {
        e.preventDefault();
        const option=countryOptions.querySelectorAll('[role="option"]')[activeCountry];
        if(option)chooseCountry(option.dataset.country);
      }
    });
    countryOptions.addEventListener('mousedown',e=>e.preventDefault());
    countryOptions.addEventListener('click',e=>{const option=e.target.closest('[data-country]');if(option)chooseCountry(option.dataset.country);});
    $('.fl-country-picker').addEventListener('keydown',e=>{if(e.key==='Escape'&&!countryPanel.hidden){e.preventDefault();e.stopPropagation();closeCountries(true);}});
    $('.fl-country-picker').addEventListener('focusout',()=>setTimeout(()=>{if(!$('.fl-country-picker').contains(document.activeElement))closeCountries();},0));
    function card(p) {
      const distance=state.origin && validPoint([p.lat,p.lon]) ? haversine(state.origin,[p.lat,p.lon]) : null;
      const website=safeUrl(p.website), contact=safeUrl(p.inquiry_url)||safeUrl(p.email ? 'mailto:'+p.email : '',['mailto:'])||website||safeUrl(p.phone ? 'tel:'+p.phone : '',['tel:']);
      const logo=safeUrl(p.logo);
      return '<article class="fl-card'+(p.recommended?' is-reco':'')+'" data-partner="'+esc(p.id)+'"><div class="fl-card-top"><div class="fl-logo">'+(logo?'<img src="'+esc(logo)+'" alt="" width="52" height="52" loading="lazy">':'🔧')+'</div><div class="fl-card-id">'+(website?'<a class="fl-card-name" href="'+esc(website)+'" target="_blank" rel="noopener">'+esc(p.name)+'</a>':'<div class="fl-card-name">'+esc(p.name)+'</div>')+'<div class="fl-card-meta">'+esc(p.city)+' · '+esc(name(p.country))+(p.reach?' · '+esc(t(p.reach)):'')+'</div></div>'+(distance!==null?'<span class="fl-dist">'+esc(t('distance'))+' '+Math.round(distance)+' km</span>':'')+'</div><div class="fl-badges">'+(p.certified?'<span class="fl-badge" data-flappie-badge="flappie-certified">'+esc(t('certified'))+'</span>':'')+(p.recommended?'<span class="fl-badge is-reco">'+esc(t('recommended'))+'</span>':'')+'</div><div class="fl-svcs">'+p.services.map(s=>'<span class="fl-svc'+(state.service===s?' is-primary':'')+'">'+esc(t(s))+'</span>').join('')+'</div>'+(contact?'<a class="fl-cta" href="'+esc(contact)+'" target="_blank" rel="noopener">'+esc(t('contact'))+'</a>':'')+'</article>';
    }
    function render() {
      const inCountry=served(state.country);
      cert.hidden=!inCountry.some(p=>p.certified);
      if(cert.hidden) state.cert=false;
      cert.setAttribute('aria-pressed',String(state.cert)); cert.classList.toggle('is-active',state.cert);
      wrap.querySelectorAll('[data-svc]').forEach(button=>{
        const svc=button.dataset.svc;
        button.hidden=svc!=='all' && !inCountry.some(p=>p.services.includes(svc));
        button.setAttribute('aria-pressed',String(svc===state.service)); button.classList.toggle('is-active',svc===state.service);
      });
      const rows=inCountry.filter(p=>(state.service==='all'||p.services.includes(state.service))&&(!state.cert||p.certified));
      const score=p => (state.origin&&validPoint([p.lat,p.lon])?haversine(state.origin,[p.lat,p.lon]):1e6)-(p.certified?bonus:0)-p.priority;
      rows.sort((a,b)=>Number(b.recommended)-Number(a.recommended)||(state.origin?score(a)-score(b):0)||a.name.localeCompare(b.name,language));
      results.innerHTML=rows.slice(0,state.shown).map(card).join('');
      $('.fl-summary').textContent=name(state.country)+' · '+rows.length+' '+t(rows.length===1?'count_one':'count')+' · '+Math.min(rows.length,state.shown)+' '+t('shown')+(state.location?' · '+state.location:'');
      $('.fl-distance-note').hidden=!state.origin;
      $('.fl-empty').hidden=rows.length>0;
      $('.fl-empty-text').textContent=t(inCountry.length?'no_filter':'no_partners');
      $('.fl-clear').hidden=!inCountry.length;
      $('.fl-more').hidden=rows.length<=state.shown;
    }
    async function ensureCoords(cc) {
      await Promise.all(partners.filter(p=>p.countries_served.includes(cc)&&!validPoint([p.lat,p.lon])&&p.plz&&registry.has(p.country)).map(async p=>{
        try { const data=await load(registry.get(p.country)), point=lookup(data,p.country,p.plz); if(point) [p.lat,p.lon]=point; } catch (_) { /* A partner remains visible when its base location is unavailable. */ }
      }));
    }
    async function search() {
      const request=++state.request, cc=state.country, query=input.value.trim(), country=registry.get(cc);
      state.origin=null; state.location=''; state.shown=limit; town.value=''; render();
      if(!query) { go.disabled=false; announce(''); return; }
      if(!country.postcode_count) { go.disabled=false; announce(t('country_only')); return; }
      go.disabled=true; announce(t('loading'));
      try {
        const data=await load(country);
        if(request!==state.request||cc!==state.country)return;
        const point=lookup(data,cc,query);
        if(!point) { announce(t('unknown')); return; }
        await ensureCoords(cc);
        if(request!==state.request||cc!==state.country)return;
        state.origin=point; state.location=query;
        announce(country.method==='postcode-area'?t('area'):''); render();
      } catch (_) { if(request===state.request) announce(t('unavailable'),true); }
      finally { if(request===state.request) go.disabled=false; }
    }
    async function populateTowns() {
      const token=++state.townRequest, cc=state.country;
      $('.fl-town-status').textContent=t('loading');
      try {
        const data=await load(registry.get(cc));
        if(token!==state.townRequest||cc!==state.country)return;
        const query=townSearch.value.trim().toLocaleLowerCase(language);
        const matches=data.towns.filter(r=>(r.name+' '+r.ascii+' '+r.region).toLocaleLowerCase(language).includes(query));
        const duplicates = new Map();
        matches.forEach(r => { const label=r.name+' · '+r.region; duplicates.set(label,(duplicates.get(label)||0)+1); });
        town.innerHTML='<option value="">'+esc(t('town_prompt'))+'</option>'+matches.slice(0,100).map(r=>{
          let label=r.name+' · '+r.region;
          if(duplicates.get(label)>1) label+=' ('+r.point[0].toFixed(3)+', '+r.point[1].toFixed(3)+')';
          return '<option value="'+esc(r.id)+'">'+esc(label)+'</option>';
        }).join('');
        $('.fl-town-status').textContent=matches.length?Math.min(100,matches.length)+' / '+matches.length+' '+t('shown'):t('no_towns');
      } catch (_) { if(token===state.townRequest) { $('.fl-town-status').textContent=t('unavailable'); announce(t('unavailable'),true); } }
    }
    function changeCountry(cc) {
      state.country=cc; $('.fl-country-value').textContent=name(cc); state.request++; state.townRequest++; state.origin=null; state.location=''; state.service='all'; state.cert=false; state.shown=limit;
      input.value=''; input.inputMode=registry.get(state.country).inputmode;
      input.disabled=!registry.get(state.country).postcode_count; go.disabled=false;
      townSearch.value=''; town.innerHTML='<option value="">'+esc(t('town_prompt'))+'</option>'; $('.fl-town-status').textContent='';
      announce(registry.get(state.country).postcode_count?'':t('country_only')); render();
      if($('.fl-town-panel').open) populateTowns();
    }
    go.addEventListener('click',search);
    input.addEventListener('keydown',e=>{if(e.key==='Enter') { e.preventDefault(); search(); }});
    input.addEventListener('input',()=>{state.request++;state.origin=null;state.location='';go.disabled=false;announce('');render();});
    $('.fl-town-panel').addEventListener('toggle',()=>{if($('.fl-town-panel').open) populateTowns();});
    let debounce;
    townSearch.addEventListener('input',()=>{clearTimeout(debounce);debounce=setTimeout(populateTowns,150);});
    town.addEventListener('change',async()=>{
      const request=++state.request, cc=state.country, id=town.value;
      state.origin=null;state.location='';input.value='';go.disabled=false;render();
      if(!id) {announce('');return;}
      try {
        const data=await load(registry.get(cc));
        const place=data.towns.find(r=>r.id===id); await ensureCoords(cc);
        if(request!==state.request||!place)return;
        state.origin=place.point;state.location=place.name+' · '+place.region;announce('');render();
      } catch (_) {if(request===state.request)announce(t('unavailable'),true);}
    });
    $('.fl-retry').addEventListener('click',()=>{if(input.value.trim())search();if($('.fl-town-panel').open)populateTowns();});
    wrap.querySelectorAll('[data-svc]').forEach(button=>button.addEventListener('click',()=>{state.service=button.dataset.svc;state.shown=limit;render();}));
    cert.addEventListener('click',()=>{state.cert=!state.cert;state.shown=limit;render();});
    $('.fl-clear').addEventListener('click',()=>{state.service='all';state.cert=false;render();});
    $('.fl-more').addEventListener('click',()=>{state.shown+=limit;render();});
    const defaultCountry=canonical(wrap.dataset.defaultCountry);
    changeCountry(registry.has(defaultCountry)?defaultCountry:'CH');
  }
  if(typeof module!=='undefined'&&module.exports) module.exports={normalise,postcodeKey,lookup,validPoint,validate,haversine,load};
  if(typeof document!=='undefined') {
    const boot=()=>document.querySelectorAll('.fl-wrap[data-flappie-finder]').forEach(init);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
    document.addEventListener('shopify:section:load',boot);
  }
})();
